import { CancelScheduleSend, Check, CheckCircle, ContactSupport, Error, ManageAccounts, Payment, PictureAsPdfSharp, Unsubscribe } from "@mui/icons-material";
import { AlertColor, Box, Checkbox, Divider, FormControl, FormControlLabel, FormLabel, Grid, LinearProgress, Paper, Radio, RadioGroup, Step, StepLabel, Stepper, TableCell, TableRow, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { KeyDriveBodyMin } from "../../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMin";
import { KeyDriveh4Header } from "../../../components/KeydriveComponents/Fonts/Headers/KeyDriveh4Header";
import { useEffect, useState } from "react";
import { GetContractBC } from "../../../services/ContractService";
import { ContractSizeByOrgName, GetAllSubscriptionInvoice, GetOneOrganization, GetPaymentInformation } from "../../../services/OrganizationServices";
import { ContractBC } from "../../../model/ContractBCModel";
import moment from "moment";
import { EnumContractStatus } from "../../../enums/EnumContractStatus";
import { bytesConverter } from "../Dashboard/components/MemoryProgress/bytesConverter";
import { EmptyContainer } from "../../../components/KeydriveComponents/EmptyContainer/EmptyContainer";
import { SupportButton } from "../../../components/Button/SupportButton/SupportButton";
import { KeyDriveBodyMax } from "../../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMax";
import { KeydriveTextfield } from "../../../components/KeydriveComponents/Textfield/KeydriveTextfield";
import { KeyDrivePrimaryButton } from "../../../components/KeydriveComponents/Buttons/KeyDrivePrimaryButton";
import AccountPlanCard from "./components/AccountPlanCard";
import AccountPaymentCard from "./components/AccountPaymentCard";
import { GenericTable } from "../UsersAndGroups/components/GenericTable/GenericTable";
import { styles } from "./Styles/styles";
import KeydriveSnackbar from "../../../components/KeydriveComponents/Snackbar/KeydriveSnackbar";
import { KeyDriveDialog } from "../../../components/KeydriveComponents/Dialog/KeyDriveDialog";
import { EnumSignture, KeydrivePlan } from "../../../model/UserModel";
import { CancelSubscription, RealCancelSubscription, UpdatePaymentMethodAsync } from "../../../services/PaymentService";
import { CancellationDetailsFeedbackEnum, ICancelSubscriptionVO } from "../../../model/PaymentModels";
import { useProfile } from "../../../context/ProfileProvider/useProfile";
import { KeyDriveChip } from "../../../components/KeydriveComponents/Tags/KeyDriveChip";
import useInvoiceStatus from "../../../hooks/useInvoiceStatus";
import { GetLastUrlPathLocalStorage } from "../../PublicLayout/RedirectManager";
import { AddressElement, CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import { LoadingStep } from "../../Plan/ChoosePlan";
import { useAuth } from "../../../context/AuthProvider/useAuth";
import { formatCurrency } from "../../../utils/FormatCurrency";
import { getInitialContract, storageTotalSizeContracted } from "../../../helpers/ContractHelper";

export interface IPaymentInformation {
    email: string;
    cvc: string;
    expMonth: number;
    expYear: number;
    cardNumber: string;
    cardBrand: string;
}

export interface IInvoice {
    invoiceId: string;
    costumerEmail: string;
    invoiceStatus: string;
    invoiceUrl: string;
    total: number;
}

export interface ICreditCardInformations {
    userEmail: string;
    cardNumber: string;
    cardExpireDate: string;
    cvc: string;
    contractId?: string;
    cockpitContractId?:string;
}

export interface IInvoiceRow {
    invoice: IInvoice;
}

export const AccountAndSubscription = () => {
    const { t } = useTranslation();
    const { nameOrg } = useParams();
    const [contract, setContract] = useState<ContractBC>(getInitialContract());
    const [error, setError] = useState<any | undefined>(undefined);
    const [contectTotalContracted, setContectTotalContracted] = useState<string>(storageTotalSizeContracted);
    const [creditCardInformations, setCreditCardInformations] = useState<ICreditCardInformations>({
        cardExpireDate: "**/*0",
        cardNumber: "**** **** **** **35",
        userEmail: "c******@gmail.com",
        cvc: "***"
    });
    const [paymentInformation, setPaymentInformation] = useState<IPaymentInformation>();
    const [editingCreditCardInfo, setEditingCreditCardInfo] = useState<boolean>(false);
    const [loadingCreditCardInformations, setLoadingCreditCardInformations] = useState<boolean>(false);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const INVOICE_PER_PAGE = 10;
    const [invoices, setInvoices] = useState<IInvoice[]>([]);
    const [message, setMessage] = useState<string | undefined>(undefined);
    const [snackbarVariant, setSnackbarVariant] = useState<AlertColor>("success");
    const navigate = useNavigate();
    const [openCancelSubscriptionDialog, setOpenCancelSubscriptionDialog] = useState<boolean>(false);
    const [openCancelSubscriptionDialogResult, setOpenCancelSubscriptionDialogResult] = useState<boolean>(false);
    const [opencancelSigntureRightNow, setCancelSigntureRightNow] = useState<boolean>(false);
    const [openRecoverySubscriptionDialogResult, setOpenRecoverySubscriptionDialogResult] = useState<boolean>(false);
    const [feedback, setFeedback] = useState<CancellationDetailsFeedbackEnum>(CancellationDetailsFeedbackEnum.CustumerService);
    const [comments, setComments] = useState<string>("");
    const profile = useProfile();
    const [contractError, setContractError] = useState<boolean>(false);
    const [openEditPaymentMethodModal, setOpenEditPaymentMethodModal] = useState<boolean>(false);
    const stripe = useStripe();
    const elements = useElements();
    const [loadingModal, setLoadingModal] = useState<boolean>(false);
    const [successModal, setSuccessModal] = useState<boolean>(false);
    const [loadingStep, setLoadingStep] = useState<LoadingStep>(null);
    const [errorModal, setErrorModal] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);
    const auth = useAuth();
    const [adminAccessDenied, setAdminAccessDenied] = useState(false);

    useEffect(() => {
        if (nameOrg != "" && nameOrg != undefined) {
            GetOneOrganization(nameOrg)
            .then(data => {
                if (data?.adminUsers != undefined) {
                    if (data?.adminUsers.includes(profile?.id!)) {
                       setAdminAccessDenied(false); 
                    } else {
                        setAdminAccessDenied(true);
                    }
                }
            })
        }
    }, [nameOrg, profile])

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFeedback(event.target.value as CancellationDetailsFeedbackEnum);
    };

    useEffect(() => {   
        if(!profile.adminSystem || !adminAccessDenied) {
            GetContractBCAsync();
            getContractSizeByOrgName(nameOrg!);
        }
        

        if (profile?.signtureInformation?.currentPlan != KeydrivePlan.PERSONAL && 
            profile?.signtureInformation?.currentPlan != KeydrivePlan.FREE
        ) {
            fetchPaymentInformation();
            fetchAllSubscriptionInvoices();
        }

    }, [nameOrg]);

    function showStatusContract(status: number) {
        switch (status) {
            case EnumContractStatus.hold:
                return "Hold"
            case EnumContractStatus.free:
                return "Free"
            case EnumContractStatus.premium:
                return "Premium"
            case EnumContractStatus.canceled:
                return "Cancelado"
            default:
                return "Sem Status"
        }
    }

    async function GetContractBCAsync() {
        try {
            if (nameOrg !== undefined) {
                const response = await GetContractBC(nameOrg);
                setContract(response);
            }
        } catch(err: any) {
            setError(true);
        }
    }

    function fetchAllSubscriptionInvoices()
    {
        if (profile?.signtureInformation?.currentPlan != KeydrivePlan.PERSONAL) {
            GetAllSubscriptionInvoice(nameOrg!)
            .then(data => {
                setInvoices(data);
            })
            .catch(err => {
                setMessage(err.response.data);
                setSnackbarVariant("error");
            })
        }
    }

    async function cancelSubscriptionAsync() {
        try {
            const inputCancel: ICancelSubscriptionVO = {
                comments: comments,
                feedbacks: feedback,
                contractId: contract?.idContract!,
                organizationInternalName: nameOrg!,
                userEmail: profile.login!
            }

            await CancelSubscription(inputCancel);

            setOpenCancelSubscriptionDialogResult(true);
        } catch(err: any) {
            setMessage(err.response?.data);
            setSnackbarVariant("error");
        } 
    }

    async function fetchPaymentInformation()
    {
        if (profile?.signtureInformation?.currentPlan != KeydrivePlan.PERSONAL) {
            setLoadingCreditCardInformations(true);
            try
            {
                const response = await GetPaymentInformation(nameOrg!);
                setPaymentInformation(response);
            } catch(err: any) {
                setMessage(err.response?.data);
                setSnackbarVariant("error");
            }
            finally 
            {
                setLoadingCreditCardInformations(false);
            }
        }
    }

    function getContractSizeByOrgName(nameOrg: string) {
        ContractSizeByOrgName(nameOrg)
            .then(data => {
                if (data !== undefined) {
                    let maxValue = Math.max(...data.sizeOrganizations.flatMap(x => x.workspaces.flatMap(x => x.size.storageUseTotal)));

                    let size = bytesConverter(data.hasContract! ? data.totalResouce.storageUseTotal : maxValue)
                    setContectTotalContracted(size??storageTotalSizeContracted);
                }
            }
        )
    }

    const getLoadingSteps = () => {
        return [
            t("AccountAndSubscription.LabelStepsPayments.ValidatingData"),
            t("AccountAndSubscription.LabelStepsPayments.CreatingPaymentMethod"),
            t("AccountAndSubscription.LabelStepsPayments.UpdatingPaymentMethod"),
            t("AccountAndSubscription.LabelStepsPayments.Finalizing"),
        ];
    };

    const getCurrentStepIndex = () => {
        switch (loadingStep) {
            case 'validating': return 0;
            case 'creating-payment': return 1;
            case 'processing': return 2;
            case 'finalizing': return 3;
            case 'complete': return 4;
            default: return 0;
        }
    };

    async function handleUpdatePaymentMethod() {
        setLoadingModal(true);
        
        try {
            setLoadingStep('validating');
            await new Promise(resolve => setTimeout(resolve, 800));

            console.log("passo 1")

            const cardElement = elements?.getElement(CardElement);
            const addressElement = elements?.getElement(AddressElement);
            const addressElValue = await addressElement?.getValue();

            cardElement?.blur();
            addressElement?.blur();

            console.log("passo 2")

            if (!addressElValue?.complete) {
                console.log("passo 3")

                setLoadingModal(false);
                setLoadingStep(null);
                setErrorModal(true);
                return;
            }

            setLoadingStep('creating-payment');
            await new Promise(resolve => setTimeout(resolve, 1000));

            const stripePmRequest = await stripe?.createPaymentMethod({
                card: cardElement!,
                type: "card",
                billing_details: {
                    email: profile?.login!,
                    address: {
                        city: addressElValue?.value.address.city,
                        country: addressElValue?.value.address.country,
                        line1: addressElValue?.value.address.line1,
                        line2: addressElValue?.value.address.line2,
                        postal_code: addressElValue?.value.address.postal_code,
                        state: addressElValue?.value.address.state
                    },
                    name: addressElValue?.value.name,
                    phone: addressElValue?.value.phone!
                }
            });

            if (stripePmRequest?.error != undefined) {
                setLoadingModal(false);
                setLoadingStep(null);
                setErrorModal(true);
                return;
            }

            setLoadingStep('processing');
            await new Promise(resolve => setTimeout(resolve, 1000));

            await UpdatePaymentMethodAsync({
                paymentMethodId: stripePmRequest?.paymentMethod?.id!,
                Address: {
                    city: addressElValue?.value.address.city!,
                    country: addressElValue?.value.address.country!,
                    line1: addressElValue?.value.address.line1!,
                    line2: addressElValue?.value.address.line2!,
                    postalCode: addressElValue?.value.address.postal_code!,
                    state: addressElValue?.value.address.state!,
                    phone: addressElValue?.value.phone!
                },
                needPayInvoices: false 
            });

            setLoadingStep('finalizing');
            await new Promise(resolve => setTimeout(resolve, 800));

            setLoadingStep('complete');
            await new Promise(resolve => setTimeout(resolve, 1000));

            setLoadingModal(false);
            setLoadingStep(null);
            setSuccessModal(true);
            setOpenEditPaymentMethodModal(false);
            
        } catch (error: any) {
            setLoadingModal(false);
            setLoadingStep(null);
            setErrorModal(true);
            setErrorMessage(error.response.data);
        }
    }

    return (
        <Box sx={{
            padding: '15px 30px',
            backgroundColor: '#F7F8FA',
            height: '100%'
        }}>
                <Box sx={{
                    background: '#FFFFFF 0% 0% no-repeat padding-box',
                    border: '1px solid #0000001A',
                    borderRadius: '4px',
                    padding: '30px 30px 0',
                    height: 'calc(100vh - 150px)'
                }}>
                    <Box sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: '15px',
                        height: '100%'
                    }}>
                        <Box sx={{
                            display: 'flex',
                            flexDirection: "row",
                            gap: '12px',
                        }}>
                            <ManageAccounts sx={{
                                color: "#22638D",
                                alignSelf: 'self-end',
                                width: '27px',
                                height: '27px',
                            }} widths='24px' height='24px' />
                            <KeyDriveh4Header
                                color="#2D2D2D"
                                needEllipses={false}
                                text={t('AdminConsole.AccountAndSubscription')}
                                needBold
                            />
                        </Box>
                        <Box>
                            <KeyDriveBodyMin
                                needEllipses={false}
                                color="#969696"
                                text={t('AdminConsole.ManageYourAccountAndSubscriptionEnsuringFullControlOverImportantSettings')}
                                needBold={false}
                            />
                        </Box>
                        {/* {(!contract && error == undefined) ? <LinearProgress /> : !error && } */}
                        <Divider />
                        {(!error) ?
                            <Box style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "20px",
                                overflowY: "auto"
                            }}>
                                <Box style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "12px"
                                }}>
                                    <Typography sx={styles.sectionTitle}>{t("AdminConsole.ClientInformation")}</Typography>
                                    <Box sx={{ display: 'flex', gap: '20px' }}>
                                        <Box flex={1}>
                                            <Typography sx={styles.label} >{t("AdminConsole.Company")}</Typography>
                                            <TextField
                                                disabled
                                                value={contract?.nameCustumer}
                                                variant="standard"
                                                placeholder={t("AdminConsole.Company")}
                                                sx={styles.textField}
                                            />
                                        </Box>
                                        <Box flex={1}>
                                            <Typography sx={styles.label} >{t("AdminConsole.Responsible")}</Typography>
                                            <TextField
                                                disabled
                                                value={contract?.respCustumer}
                                                variant="standard"
                                                placeholder={t("AdminConsole.Responsible")}
                                                sx={styles.textField}
                                            />
                                        </Box>
                                        <Box flex={1.2}>
                                            <Typography sx={styles.label} >{t("AdminConsole.ResponsiblePersonEmail")}</Typography>
                                            <TextField
                                                disabled
                                                value={contract?.emailResp}
                                                variant="standard"
                                                placeholder={t("AdminConsole.ResponsiblePersonEmail")}
                                                sx={styles.textField}
                                            />
                                        </Box>
                                        <Box flex={1}>
                                            <Typography sx={styles.label} >{t("AdminConsole.CellPhone")}</Typography>
                                            <TextField
                                                disabled
                                                value={contract?.phone}
                                                variant="standard"
                                                placeholder={t("AdminConsole.CellPhone")}
                                                sx={styles.textField}
                                            />
                                        </Box>
                                    </Box>
                                </Box>
                                <Box style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "12px"
                                }}>
                                    <Typography sx={styles.sectionTitle}>{t("AdminConsole.ContractInformation")}</Typography>
                                    <Box sx={{ display: 'flex', gap: '20px' }}>
                                        <Box flex={1}>
                                            <Typography sx={styles.label} >{t("AdminConsole.ContractNumber")}</Typography>
                                            <TextField
                                                disabled
                                                value={contract?.contractNumber}
                                                variant="standard"
                                                placeholder={t("AdminConsole.ContractNumber")}
                                                sx={styles.textField}
                                            />
                                        </Box>
                                        <Box flex={1}>
                                            <Typography sx={styles.label} >{t("AdminConsole.TermOfTheContract")}</Typography>
                                            <TextField
                                                disabled
                                                value={moment(contract?.contractValidity).format('DD/MM/yyyy')}
                                                variant="standard"
                                                placeholder={t("AdminConsole.TermOfTheContract")}
                                                sx={styles.textField}
                                            />
                                        </Box>
                                        <Box flex={1}>
                                            <Typography sx={styles.label} >{t("AdminConsole.TotalContractValue")}</Typography>
                                            <TextField
                                                disabled
                                                value={`${formatCurrency(contract?.price!)}`}
                                                variant="standard"
                                                placeholder={t("AdminConsole.TotalContractValue")}
                                                sx={styles.textField}
                                            />
                                        </Box>
                                    </Box>
                                </Box>
                                <Box style={{
                                    display: "flex",
                                    gap: "12px",
                                    width: "100%",
                                    justifyContent: "space-between"
                                }}>
                                    <AccountPlanCard 
                                        contractStorage={contectTotalContracted!}
                                        planStatus={showStatusContract(contract?.status!)}
                                        price={contract?.price!.toString()!}
                                        totalUsers={contract?.totalUsers!.toString()!}
                                        usersUsed={contract?.usersUsed!}
                                        plan={contract?.plan!}
                                    />
                                    { profile?.signtureInformation?.signture == EnumSignture.Premium && (
                                       <>
                                            { profile?.signtureInformation?.currentPlan != KeydrivePlan.PERSONAL && (
                                                <AccountPaymentCard 
                                                    creditCardInformations={creditCardInformations}
                                                    editingCreditCardInfo={editingCreditCardInfo}
                                                    setCreditCardInformations={setCreditCardInformations}
                                                    setEditingCreditCardInfo={setEditingCreditCardInfo}
                                                    cockpitContractId={contract?.idContractCockpit!}
                                                    contractId={contract?.idContract!}
                                                    paymentInformation={paymentInformation!}
                                                    loadingInformations={loadingCreditCardInformations}
                                                    setOpenEditPaymentMethodModal={setOpenEditPaymentMethodModal}
                                                />
                                            ) }
                                       </> 
                                    ) }
                                </Box>
                               { invoices !== undefined && profile?.signtureInformation?.currentPlan != KeydrivePlan.PERSONAL && profile?.signtureInformation?.currentPlan != KeydrivePlan.FREE && (
                                 <GenericTable 
                                    headers={[
                                        t("AccountAndSubscription.IdInvoice"),
                                        t("AccountAndSubscription.Username"),
                                        t("AccountAndSubscription.StatusInvoice"),
                                    ]}
                                    bodyData={invoices?.map((invoice) => ( 
                                        <InvoiceRow invoice={invoice} /> 
                                    ))}
                                    currentPage={currentPage} 
                                    onPageChange={setCurrentPage}
                                    dataPerPage={INVOICE_PER_PAGE}
                                />
                               ) } 
                                <Box style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "12px"
                                }}>
                                    
                                    <Typography sx={styles.sectionTitle}>{t("AdminConsole.LoginWithOffice365")}</Typography>
                                    <Typography sx={styles.description} >{t("AdminConsole.DescriptionLoginWithOffice365")}</Typography>
                                    <FormControlLabel control={
                                        <Checkbox checked={contract?.loginType == 2} disabled />
                                    } label={t("AdminConsole.AllowsLoginWithOffice365")} />

                                </Box>
                                <Box gap={2} display="flex">
                                    { profile?.signtureInformation?.currentPlan != KeydrivePlan.FREE && profile?.signtureInformation?.currentPlan != KeydrivePlan.PERSONAL && (profile?.signtureInformation?.cancelAt == null) && (
                                        <Box marginRight="10px">
                                            <KeyDrivePrimaryButton 
                                                TextComponent={KeyDriveBodyMin}
                                                TextComponentProps={{
                                                    color: "",
                                                    needBold: false,
                                                    needEllipses: false,
                                                    text: t("AccountAndSubscription.CancelSubscription"),
                                                }}
                                                onClick={() => {
                                                    setOpenCancelSubscriptionDialog(true);
                                                }}
                                                disabled={profile?.signture?.cancelAt !== undefined}
                                            />
                                        </Box>
                                    ) }
                                </Box>
                                <Box style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    border: "1px solid #EAEAEA",
                                    borderRadius: "4px",
                                    padding: "5px 8px",
                                    marginBottom: "10px"

                                }}>
                                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                        <ContactSupport sx={{
                                            color: "#22638D",
                                            alignSelf: 'self-end'
                                        }} />
                                        <Typography sx={{
                                            font: 'normal normal 600 16px/24px Segoe UI',
                                            fontWeight: 'semibold',
                                            color: '#2D2D2D',
                                        }}>{t("AdminConsole.NeedToTalkToSupport")}</Typography>
                                        <Typography sx={{
                                            font: 'normal normal normal 14px/21px Segoe UI',
                                            color: '#2D2D2D',
                                        }}>{t("AdminConsole.ContactOurSupportTeamByClickingTheButtonNextToIt")}</Typography>
                                    </div>

                                    <SupportButton />

                                </Box>
                            </Box>
                            : <div style={{ marginBottom: "10px", height: "100%" }}>
                                <EmptyContainer
                                    content={t('AdminConsole.DescriptionNoExistingContract')}
                                    title={t('AdminConsole.NoExistingContract')}
                                    icon={<ManageAccounts sx={{ height: "122px", width: "120px", color: "#d2e0e8" }} />}
                                />
                            </div>
                        }
                    </Box>
                </Box>
            
            <KeydriveSnackbar 
                open={message != undefined}
                onClose={() => setMessage(undefined)}
                message={message}
                variant={snackbarVariant}
            />

        <KeyDriveDialog 
            dialogTitleCenter={false}
            keyDriveDialogButtons={{
                leftButtonMethod: () => { setOpenCancelSubscriptionDialog(false) },
                rightButtonMethod: () => {
                    setOpenCancelSubscriptionDialog(false);
                    cancelSubscriptionAsync();
                },
                rightButtonText: t("AdminConsole.Continue"),
                leftButtonText: t("AdminConsole.Cancel")
            }}
            keyDriveDialogContent={{
                dialogContent: 
                <Grid container>
                    <Grid item xs={12}>
                        <FormControl>
                            <FormLabel id="demo-controlled-radio-buttons-group">{t("AccountAndSubscription.CancelSubscriptionMotivate")}</FormLabel>
                            <RadioGroup
                                aria-labelledby="demo-controlled-radio-buttons-group"
                                name="controlled-radio-buttons-group"
                                value={feedback}
                                onChange={handleChange}
                            >
                                <FormControlLabel value={CancellationDetailsFeedbackEnum.CustumerService} control={<Radio />} label={t("AccountAndSubscription.ClientServices")}/>
                                <FormControlLabel value={CancellationDetailsFeedbackEnum.MissingFeatures} control={<Radio />} label={t("AccountAndSubscription.NoFeatures")} />
                                <FormControlLabel value={CancellationDetailsFeedbackEnum.SwitchedService} control={<Radio />} label={t("AccountAndSubscription.SwitchServices")} />
                                <FormControlLabel value={CancellationDetailsFeedbackEnum.Other} control={<Radio />} label={t("AccountAndSubscription.Others")} />
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sx={{
                        marginBottom: "4px"
                    }}>
                        <KeydriveTextfield 
                            onChange={(e) => { setComments(e.currentTarget.value)}}
                            value={comments}
                            label={t("AccountAndSubscription.AddCancelComments")}
                            needFullWidth
                        />
                    </Grid>
                </Grid>,
                dialogIcon: <Unsubscribe sx={{ color: "#22638D", width: "44px", height: "44px" }}/>,
                dialogTitle: t("AdminConsole.CancelSubscriptionDialogTitle"),
                handleTogglDialog: () => {},
                openDialog: openCancelSubscriptionDialog,
            }}
        />

            <KeyDriveDialog 
                keyDriveDialogButtons={{
                    leftButtonMethod: () => { setOpenCancelSubscriptionDialogResult(false) },
                    rightButtonMethod: () => {
                        setOpenCancelSubscriptionDialogResult(false);
                        navigate(`/${nameOrg}/adminConsole/plans`);
                    },
                    rightButtonText: t("AdminConsole.FreeTier.AccessPlans")
                }}
                keyDriveDialogContent={{
                    dialogContent: t("Payment.CancelSubscriptionSuccess"),
                    dialogIcon: <CancelScheduleSend sx={{ color: "#22638D", width: "44px", height: "44px" }}/>,
                    dialogTitle: t("Payment.CancelSubscriptionTitle"),
                    handleTogglDialog: () => {},
                    openDialog: openCancelSubscriptionDialogResult
                }}
                dialogTitleCenter
            />

            <KeyDriveDialog 
                keyDriveDialogButtons={{
                    leftButtonMethod: () => { setOpenRecoverySubscriptionDialogResult(false) },
                    rightButtonMethod: () => {
                        setOpenRecoverySubscriptionDialogResult(false);
                    },
                    rightButtonText: t("AccountAndSubscription.RecoverySubscription"),
                    leftButtonText: `${t("AccountAndSubscription.Back")}`
                }}
                keyDriveDialogContent={{
                    dialogContent: t("AccountAndSubscription.RecoverySubscriptionDialogContent"),
                    dialogIcon: <Check sx={{ color: "#22638D", width: "44px", height: "44px" }}/>,
                    dialogTitle: t("AccountAndSubscription.RecoverySubscription"),
                    handleTogglDialog: () => {},
                    openDialog: openRecoverySubscriptionDialogResult
                }}
                dialogTitleCenter
            />

            <KeyDriveDialog 
                keyDriveDialogButtons={{
                    leftButtonMethod: () => { setCancelSigntureRightNow(false) },
                    rightButtonMethod: () => {
                        RealCancelSubscription(nameOrg!)
                            .then(() => {
                                setMessage(t("AccountAndSubscription.SubscriptionCancelledSuccessfully"));
                                setSnackbarVariant("success");
                                setCancelSigntureRightNow(false);
                            })
                            .catch((err) => {
                                setMessage(err.response.data);
                                setSnackbarVariant("error");
                            })
                    },
                    rightButtonText: t("AccountAndSubscription.Confirm"),
                    leftButtonText: t("AccountAndSubscription.Back")
                }}
                keyDriveDialogContent={{
                    dialogContent: t("AccountAndSubscription.CancelSubscriptionImmediatelyWarning"),
                    dialogIcon: <Check sx={{ color: "#22638D", width: "44px", height: "44px" }}/>,
                    dialogTitle: t("AccountAndSubscription.CancelSubscriptionRightNow"),
                    handleTogglDialog: () => {},
                    openDialog: opencancelSigntureRightNow
                }}
                dialogTitleCenter
            />

            { !profile?.adminSystem && (
                <KeyDriveDialog 
                    keyDriveDialogButtons={{
                        leftButtonMethod: () => { setContractError(false) },
                        rightButtonMethod: () => {
                            if (GetLastUrlPathLocalStorage() !== null) {
                                navigate(GetLastUrlPathLocalStorage() as string);
                            } else {
                                navigate("/");
                            }
                        },
                        rightButtonText: "Confirmar",
                    }}
                    keyDriveDialogContent={{
                        dialogContent: t("AdminConsole.ErrorContract"),
                        dialogIcon: <Error sx={{ color: "#22638D", width: "44px", height: "44px" }}/>,
                        dialogTitle: t("AdminConsole.ErroContractTitle"),
                        handleTogglDialog: () => {},
                        openDialog: contractError
                    }}
                    dialogTitleCenter
                />
            ) }

            { profile?.adminSystem && (
                <KeyDriveDialog 
                    keyDriveDialogButtons={{
                        leftButtonMethod: () => { setAdminAccessDenied(false) },
                        rightButtonMethod: () => {
                            if (GetLastUrlPathLocalStorage() !== null) {
                                navigate(GetLastUrlPathLocalStorage() as string);
                            } else {
                                navigate("/");
                            }
                        },
                        rightButtonText: t("AdminConsole.Confirm") || "Confirmar",
                    }}
                    keyDriveDialogContent={{
                        dialogContent: t("Security.AdminAccessDeniedMessage") || "Por questões de segurança e conformidade com a LGPD, administradores do sistema não têm acesso a páginas contendo dados sensíveis de pagamento e informações pessoais dos usuários. Esta restrição protege a privacidade dos dados e garante o princípio do privilégio mínimo.",
                        dialogIcon: <Error sx={{ color: "#22638D", width: "44px", height: "44px" }}/>,
                        dialogTitle: t("Security.AdminAccessDeniedTitle") || "Acesso Restrito - Administrador",
                        handleTogglDialog: () => {},
                        openDialog: adminAccessDenied
                    }}
                    dialogTitleCenter
                />
            )}

            { openEditPaymentMethodModal && (
                <KeyDriveDialog
                    hidden={
                        loadingModal || successModal || errorModal
                    }
                    keyDriveDialogButtons={{
                        leftButtonMethod() {
                            setOpenEditPaymentMethodModal(false);
                        },
                        rightButtonMethod: () => {
                            handleUpdatePaymentMethod();
                        },
                        rightButtonText: t("Signture.SetupNewPaymentMethod"),
                        leftButtonText: t("AdminConsole.Cancel")
                    }}
                    keyDriveDialogContent={{
                        dialogContent: (
                            <>
                            <Box sx={{ mb: 3 }}>
                                <KeyDriveBodyMin 
                                    color='#0a1929'
                                    needBold={true}
                                    needEllipses={false}
                                    text={t("AccountAndSubscription.CardDetails")}
                                />
                                <Paper 
                                    elevation={0}
                                    sx={{ 
                                        p: 2.5, 
                                        mt: 1.5,
                                        border: '1px solid #e0e0e0',
                                        borderRadius: 2,
                                        '&:focus-within': {
                                            borderColor: '#22638D',
                                            boxShadow: '0 0 0 2px rgba(34, 99, 141, 0.1)'
                                        }
                                    }}
                                >
                                    <CardElement 
                                        options={{
                                            style: {
                                                base: {
                                                    fontSize: "16px",
                                                    color: "#0a1929",
                                                    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                                                    "::placeholder": {
                                                        color: "#9e9e9e",
                                                    },
                                                },
                                                invalid: {
                                                    color: "#d32f2f",
                                                },
                                            },
                                            hidePostalCode: true,
                                        }}
                                    />
                                </Paper>
                            </Box>

                            <Box>
                                <KeyDriveBodyMin 
                                    color='#0a1929'
                                    needBold={true}
                                    needEllipses={false}
                                    text={t("AccountAndSubscription.BillingAddress")}

                                />
                                <Paper 
                                    elevation={0} 
                                    sx={{ 
                                        p: 2.5, 
                                        mt: 1.5,
                                        border: '1px solid #e0e0e0',
                                        borderRadius: 2
                                    }}
                                >
                                    <AddressElement 
                                        options={{
                                            allowedCountries: ["BR", "US"],
                                            mode: "billing",
                                            fields: {
                                                phone: "always",
                                            },
                                            display: {
                                                name: "full",
                                            },
                                            autocomplete: {
                                                mode: "disabled",
                                            },
                                            defaultValues: {
                                                address: {
                                                    country: "",
                                                    city: "",
                                                    line1: "",
                                                    line2: "",
                                                    postal_code: "",
                                                    state: ""
                                                },
                                                firstName: "",
                                                lastName: "",
                                                name: "",
                                                phone: ""
                                            },
                                            validation: {
                                                phone: {
                                                    required: "never"
                                                }
                                            }
                                        }}
                                    />
                                </Paper>
                            </Box>
                            </>
                        ),
                        dialogIcon: <Payment sx={{ color: "#22638D", width: "44px", height: "44px" }}/>,
                        dialogTitle:  t("Signture.EditPaymentMethod"),
                        handleTogglDialog: () => {},
                        openDialog: openEditPaymentMethodModal
                    }}
                    dialogTitleCenter
                />
            ) }

            <KeyDriveDialog 
                keyDriveDialogButtons={{
                    leftButtonMethod: () => {},
                    rightButtonMethod: () => {},
                    rightButtonText: undefined,
                    leftButtonText: undefined
                }}
                keyDriveDialogContent={{
                    dialogContent: (
                        <Box sx={{ 
                            textAlign: 'center',
                            py: 2
                        }}>
                            <KeyDriveBodyMax 
                                color='#0a1929'
                                needBold={true}
                                needEllipses={false}
                                text={t("AccountAndSubscription.ProcessingNewPaymentMethod")}
                            />
                            <Box sx={{ mt: 4, mb: 2, px: 2 }}>
                                <Stepper activeStep={getCurrentStepIndex()} alternativeLabel>
                                    {getLoadingSteps().map((label) => (
                                        <Step key={label}>
                                            <StepLabel>{label}</StepLabel>
                                        </Step>
                                    ))}
                                </Stepper>
                            </Box>
                            <LinearProgress 
                                sx={{ 
                                    mt: 3,
                                    height: 8,
                                    borderRadius: 4,
                                    bgcolor: '#e0e0e0',
                                    '& .MuiLinearProgress-bar': {
                                        bgcolor: '#22638D'
                                    }
                                }} 
                            />
                        </Box>
                    ),
                    handleTogglDialog: () => {},
                    openDialog: loadingModal
                }}
            />

            <KeyDriveDialog 
                keyDriveDialogButtons={{
                    leftButtonMethod: () => {},
                    rightButtonMethod: () => {
                        setSuccessModal(false);
                        auth.logout();
                    },
                    rightButtonText: `${t("AccountAndSubscription.ClickToLogoutAndRefresh")}`,
                    leftButtonText: undefined
                }}
                keyDriveDialogContent={{
                    dialogContent: (
                        <Box sx={{ 
                            textAlign: 'center',
                            py: 2
                        }}>
                            <Box sx={{
                                width: 80,
                                height: 80,
                                borderRadius: '50%',
                                bgcolor: '#e8f5e9',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                margin: '0 auto 24px'
                            }}>
                                <CheckCircle sx={{ color: "#4caf50", width: "56px", height: "56px" }} />
                            </Box>
                            
                            <KeyDriveBodyMax 
                                color='#0a1929'
                                needBold={true}
                                needEllipses={false}
                                text={t("AccountAndSubscription.PaymentMethodUpdatedSuccessfully")}
                            />
                            
                            <Box sx={{ mt: 2, mb: 3 }}>
                                <KeyDriveBodyMin 
                                    color='#546e7a'
                                    needBold={false}
                                    needEllipses={false}
                                    text={t("AccountAndSubscription.PaymentMethodUpdatedSuccessMessage")}
                                />
                            </Box>
                        </Box>
                    ),
                    handleTogglDialog: () => {},
                    openDialog: successModal
                }}
            />

            <KeyDriveDialog 
                keyDriveDialogButtons={{
                    leftButtonMethod: () => {},
                    rightButtonMethod: () => {
                        setErrorModal(false);
                        setOpenEditPaymentMethodModal(true);
                    },
                    rightButtonText: `${t("AccountAndSubscription.TryAgain")}`,
                    leftButtonText: undefined
                }}
                keyDriveDialogContent={{
                    dialogContent: (
                        <Box sx={{ 
                            textAlign: 'center',
                            py: 2
                        }}>
                            <Box sx={{
                                width: 80,
                                height: 80,
                                borderRadius: '50%',
                                bgcolor: '#ffebee',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                margin: '0 auto 24px'
                            }}>
                                <Box sx={{
                                    width: 56,
                                    height: 56,
                                    borderRadius: '50%',
                                    border: '4px solid #d32f2f',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    position: 'relative'
                                }}>
                                    <Box sx={{
                                        width: 4,
                                        height: 24,
                                        bgcolor: '#d32f2f',
                                        borderRadius: 1,
                                        transform: 'rotate(45deg)',
                                        position: 'absolute'
                                    }} />
                                    <Box sx={{
                                        width: 4,
                                        height: 24,
                                        bgcolor: '#d32f2f',
                                        borderRadius: 1,
                                        transform: 'rotate(-45deg)',
                                        position: 'absolute'
                                    }} />
                                </Box>
                            </Box>
                            
                            <KeyDriveBodyMax 
                                color='#0a1929'
                                needBold={true}
                                needEllipses={false}
                                text={t("AccountAndSubscription.ErrorProcessingPaymentMethod")}
                            />

                            { errorMessage != undefined && (
                                <KeyDriveBodyMin 
                                    color='#0a1929'
                                    needBold={true}
                                    needEllipses={false}
                                    text={errorMessage}
                                    sxStyles={{
                                        mt: 2,
                                    }}
                                />
                            ) }

                            <Paper 
                                elevation={0} 
                                sx={{ 
                                    p: 3, 
                                    mt: 3,
                                    bgcolor: '#fff3e0',
                                    border: '1px solid #ff9800',
                                    borderRadius: 2,
                                    textAlign: 'left'
                                }}
                            >
                                <KeyDriveBodyMin 
                                    color='#e65100'
                                    needBold={true}
                                    needEllipses={false}
                                    text={t("AccountAndSubscription.WhatToDoNow")}
                                />
                                <Box sx={{ mt: 1.5 }}>
                                    <KeyDriveBodyMin 
                                        color='#5d4037'
                                        needBold={false}
                                        needEllipses={false}
                                        text={`• ${t("AccountAndSubscription.CheckCardDetailsAndTryAgain")}`}
                                    />
                                </Box>
                                <Box sx={{ mt: 0.5 }}>
                                    <KeyDriveBodyMin 
                                        color='#5d4037'
                                        needBold={false}
                                        needEllipses={false}
                                        text={`• ${t("AccountAndSubscription.EnsureAllFieldsFilledCorrectly")}`}
                                    />
                                </Box>
                                <Box sx={{ mt: 0.5 }}>
                                    <KeyDriveBodyMin 
                                        color='#5d4037'
                                        needBold={false}
                                        needEllipses={false}
                                        text={`• ${t("AccountAndSubscription.ContactSupportIfProblemPersists")}`}
                                    />
                                </Box>
                            </Paper>
                        </Box>
                    ),
                    handleTogglDialog: () => {},
                    openDialog: errorModal
                }}
            />
        </Box>
        
    )
}

function InvoiceRow({
    invoice
}: IInvoiceRow) {


    const { statusInvoiceName } = useInvoiceStatus(invoice.invoiceStatus);

    return (
        <TableRow>
            <TableCell sx={{ width: '30px' }} />
            <TableCell sx={{ alignItems: "center", gap: 1, padding: '8px' }}>
                <Box sx={{display: 'flex', gap: '8px' }}>
                    <Box
                    sx={{
                        height: '26px',
                        width: '26px',
                        color: '#22638D',
                        backgroundColor: '#22638D1A',
                        border: "1px solid #22638D33",
                        borderRadius: '50%',
                        display: 'flex'
                    }}>
                    <PictureAsPdfSharp sx={{ height: '16px', width: '16px', margin: 'auto' }} />
                </Box>
                    <Typography 
                        sx={{ 
                            "&:hover": {
                            color: '#22638D', 
                            textDecoration: 'underline',
                            cursor: 'pointer',
                        }}}
                        component="a"
                        href={invoice.invoiceUrl}
                        target="_blank"
                    >
                    {invoice.invoiceId}
                </Typography>
                </Box>
            </TableCell>
            <TableCell sx={{ padding: '8px'}}>
                <KeyDriveBodyMin 
                    color="#2d2d2d"
                    needBold={false}
                    needEllipses={false}
                    text={invoice.costumerEmail}
                />
            </TableCell>
            <TableCell sx={{ padding: '8px', textAlign: "center"}}>
                <KeyDriveChip 
                    text={statusInvoiceName}
                    backgroundColor="#a3eda3ff"
                    color="#2d2d2d"
                />
            </TableCell>
        </TableRow>
    )
}

